import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';

import AddNewBrand from '@components/AddNewBrand';
import LoaderComponent from '@components/LoaderComponent';
import { toastError, toastSuccess } from '@components/Toast';

import ApiClient from '@lib/apiClient';

const ReviewModal = ({ showModal, closeModal, clientId, clientInfo }) => {
	const [loading, setLoading] = useState(false);
	const [brandModal, setBrandModal] = useState(false);
	const [buttonStatus, setButtonStatus] = useState('YesOrNo');
	const [searchItem, setSearchItem] = useState('');
	const [brands, setBrands] = useState([]);
	const [selectedBrand, setSelectedBrand] = useState({});
	const [, setDisabled] = useState(true);
	const [rejectOption, setRejectOption] = useState('');

	useEffect(() => {
		searchBrand();
	}, []);

	const resetState = () => {
		setButtonStatus('YesOrNo');
		setSearchItem('');
		setSelectedBrand({});
		setRejectOption('');
		closeModal();
	};

	const rejectClient = async () => {
		setLoading(true);
		await ApiClient.POST('rejectClient', 'DISABLED', clientId)
			.then(({ data }) => {
				setLoading(false);
				toastSuccess(data.message);
				resetState();
			})
			.catch(({ response }) => {
				setLoading(false);
				toastError(response.data.message);
			});
	};

	const contactLater = async (paramData) => {
		setLoading(true);
		await ApiClient.POST('contactClientLater', '', clientId + paramData)
			.then(({ data }) => {
				setLoading(false);
				toastSuccess(data.message);
				resetState();
			})
			.catch(({ response }) => {
				setLoading(false);
				toastError(response.data.message);
			});
	};

	const triggerBrandModal = async () => {
		await setBrandModal(!brandModal);
	};

	const renderRejectOptions = () => {
		return (
			<div className="select-why-content">
				<p className="regular-14 gray_dark_01 mt-3 why-select-text">Select why:</p>
				<div className="col-lg-12 px-0 mb-2">
					<input
						type="radio"
						name="reject-reason"
						id="contactLater"
						value="Contact Later"
						onClick={(e) => setRejectOption(e.target.value)}
					/>
					<label htmlFor="contactLater" className="regular-14">
						{' '}
						Didn't receive call (Contact later)
					</label>
				</div>
				<div className="col-lg-12 px-0 mb-2">
					<input
						type="radio"
						name="reject-reason"
						id="wrongNumber"
						value="Wrong Number"
						onClick={(e) => setRejectOption(e.target.value)}
					/>
					<label htmlFor="wrongNumber" className="regular-14">
						Wrong Number (Buyer will provide right number)
					</label>
				</div>

				<div className="col-lg-12 px-0 mb-0">
					<input
						type="radio"
						name="reject-reason"
						id="notValid"
						value="Invalid Buyer"
						onClick={(e) => setRejectOption(e.target.value)}
					/>
					<label htmlFor="notValid" className="regular-14">
						Buyer is not valid (Reject)
					</label>
				</div>
			</div>
		);
	};

	const handleSubmit = () => {
		if (rejectOption === 'Invalid Buyer') {
			rejectClient();
		} else if (rejectOption === 'Wrong Number') {
			contactLater('?reason=WRONG_NUMBER');
		} else if (rejectOption === 'Contact Later') {
			contactLater('?reason=CALL_NOT_RECEIVED');
		}
	};

	const renderButtons = () => {
		return (
			<>
				{(buttonStatus === 'No' || buttonStatus === 'Reject') && (
					<button className="button size32" onClick={handleSubmit}>
						Submit
					</button>
				)}
				{/*{buttonStatus === "No" &&*/}
				{/*    <button*/}
				{/*        className="button revise size32"*/}
				{/*        onClick={() => setButtonStatus("Reject")}>*/}
				{/*        No, Reject*/}
				{/*    </button>*/}
				{/*}*/}
				{/*{buttonStatus === "Reject" &&*/}
				{/*    <button*/}
				{/*        onClick={rejectClient}*/}
				{/*        className="button revise size32">*/}
				{/*        Yes*/}
				{/*    </button>*/}
				{/*}*/}
				{/*{buttonStatus === "Reject" &&*/}
				{/*    <button*/}
				{/*        className="button size32 ml-2"*/}
				{/*        onClick={() => resetState()}>*/}
				{/*        No*/}
				{/*    </button>*/}
				{/*}*/}
				{buttonStatus === 'YesOrNo' && (
					<button className="button gray-outline size32 ml-2" onClick={() => setButtonStatus('No')}>
						No
					</button>
				)}
				{buttonStatus === 'YesOrNo' && (
					<button className="button size32 ml-2" onClick={() => setButtonStatus('Yes')}>
						Yes
					</button>
				)}
				{/*{buttonStatus === "No" &&*/}
				{/*    <button*/}
				{/*        className="button size32 ml-2"*/}
				{/*        onClick={contactLater}>*/}
				{/*        Yes*/}
				{/*    </button>*/}
				{/*}*/}
				{buttonStatus === 'Yes' && (
					<button className="button revise size32" onClick={() => setButtonStatus('Reject')}>
						Reject
					</button>
				)}
				{buttonStatus === 'Yes' && (
					<button className="button approve size32 ml-2" onClick={approveBuyer}>
						Approve
					</button>
				)}
			</>
		);
	};

	const approveBuyer = async () => {
		setLoading(true);
		let brandId = selectedBrand.id;
		let pathParam = `${clientId}/${brandId}`;
		await ApiClient.POST('approveBuyer', '', pathParam)
			.then(({ data }) => {
				setLoading(false);
				toastSuccess(data.message);
				resetState();
			})
			.catch(({ response }) => {
				setLoading(false);
				toastError(response.data.message);
			});
	};

	const searchBrandItem = (e) => {
		e.preventDefault();
		setSearchItem(e.target.value);
		setDisabled(true);
		searchBrand(e.target.value !== null ? e.target.value : undefined);
	};

	const searchBrand = async (searchParam = undefined) => {
		const params = {
			page: 0,
			size: 1000
		};
		if (searchParam) {
			params['name'] = searchParam;
		}
		await ApiClient.GET('getBrandList', params)
			.then(async (response) => {
				await setBrands(response.data.data);
				await setLoading(false);
			})
			.catch(({ response }) => {
				setLoading(false);
				toastError(response.data.message);
			});
	};

	const renderBrandField = () => {
		return (
			<div className="brand-list-contents mt-3">
				<label htmlFor="">Brand name</label>
				<div className="brand-selection scroll-y-label">
					<div className="form-group size36 mb-2 search-filter">
						<div className="with-icon right-icon">
							<input
								type="text"
								autoComplete="off"
								placeholder="Search and select"
								value={searchItem}
								onChange={searchBrandItem}
							/>
							<span className="right-icon">
								<img src={process.env.PUBLIC_URL + '/icons/search.png'} alt="search" />
							</span>
						</div>
					</div>
					<div className="brand-list-with-add-brand">
						<button className="button text" onClick={triggerBrandModal}>
							<img src={process.env.PUBLIC_URL + '/icons/add_primary.svg'} alt="add" />
							<span>Add Brand</span>
						</button>
						<div className="brand-list">
							{brands.map((item) => {
								return (
									<p
										onClick={() => {
											setSelectedBrand(item);
											setSearchItem(item.name);
											setDisabled(false);
										}}
									>
										{item?.name}
									</p>
								);
							})}
						</div>
					</div>
				</div>
			</div>
		);
	};

	const setNewBrandToSelectedBrand = async (id) => {
		if (id) {
			await ApiClient.GET('getBrandInfo', id)
				.then(({ data }) => {
					setSearchItem(data.name);
					setSelectedBrand(data);
					setDisabled(false);
					setLoading(false);
				})
				.catch(({ response }) => {
					setLoading(false);
					toastError(response.data.message);
				});
		}
	};

	return (
		<>
			<Modal show={showModal} onHide={() => resetState()} centered>
				<div className="wraper container-fluid dashboard-container">
					<div className="popup-wrapper">
						<div className="common-popup review-buyer-popup shadow-24dp">
							<div className="common-popup-header d-flex justify-content-between">
								<div className="popup-tilte">
									<h3 className="semibold-16 mb-0">Review buyer </h3>
								</div>
								<div className="close-btn" onClick={() => resetState()}>
									<img src={process.env.PUBLIC_URL + '/icons/close.svg'} alt="close" />
								</div>
							</div>
							<div className="common-popup-body">
								<div className="buyer-details">
									<h3 className="semibold-16">{clientInfo?.name}</h3>
									<p className="regular-14">
										{clientInfo?.phoneNumber}
										{clientInfo.phoneNumber && <span className="devide"> | </span>}
										{clientInfo?.email}
									</p>
									<p className="regular-14">
										Brand:{' '}
										<span className="brand-name">
											{clientInfo.brandResponse
												? clientInfo.brandResponse.name
												: clientInfo.userInputtedBrandName
													? clientInfo.userInputtedBrandName
													: 'N/A'}
										</span>
									</p>
								</div>
								{buttonStatus === 'Yes' && renderBrandField()}
								{/* {buttonStatus === "Reject" && <div className="are-you-sure-content mt-3">
                                    <p className="regular-16 primary_bright_01 mb-0">Are you sure about rejecting this
                                        buyer?</p>
                                </div>} */}
								{(buttonStatus === 'No' || buttonStatus === 'Reject') &&
									renderRejectOptions()}
							</div>
							<div className="modal-footer">
								{(buttonStatus === 'Yes' || buttonStatus === 'Reject') && (
									<p className="regular-14 gray_dark_01 mb-0">&nbsp;</p>
								)}
								{buttonStatus === 'YesOrNo' && (
									<p className="regular-14 gray_dark_01 mb-0">
										Have you communicated with the buyer?
									</p>
								)}

								<div className="footer-buttons text-right">{renderButtons()}</div>
							</div>
						</div>
					</div>
				</div>
				<LoaderComponent loading={loading} />
			</Modal>
			<Modal show={brandModal} onHide={() => triggerBrandModal} size="lg" centered>
				<AddNewBrand
					brandModal={brandModal}
					triggerBrandModal={triggerBrandModal}
					setNewBrandToSelectedBrand={setNewBrandToSelectedBrand}
				/>
			</Modal>
		</>
	);
};

export default ReviewModal;
